import styled from "styled-components";
interface IProps {
  color?: string;
  isActive?: boolean;
  pillShape?: boolean;
  roundedRect?: boolean;
  heightWidth?: string;
  padding?: string;
  borderRadius?: string;
  active?: boolean;
  cursor?: string;
}

export const HalfContainer = styled.div`
  width: 50%;
`;
export const SelectedColorButton = styled.div<IProps>`
  height: ${(props) => props.heightWidth || "40px"};
  min-width: ${(props) => props.heightWidth || "40px"};
  padding: ${(props) => props.padding || "5px"};
  border: 2px solid ${(props) => (props.active ? "#57ac2d" : "#cccccc")};
  border-radius: ${(props) => props.borderRadius || "4px"};
  cursor: ${(props) => props.cursor || "pointer"};
  text-align: center;
  line-height: 28px;
  div {
    height: 100%;
    width: 100%;
    background-color: ${(props) => props.color};
    border-radius: ${(props) => props.borderRadius || "4px"};
    cursor: pointer;
  }
  img {
    height: 100%;
    width: 100%;
  }
  &.opaque-unselected {
    opacity: ${(props) => (props.active ? "1" : "0.65")};
    cursor: not-allowed;
  }
  &.opaque-selected {
    opacity: ${(props) => (props.active ? "1" : "0.65")};
    cursor: pointer;
  }
  &.colored-btn-as-input {
    height: auto;
    min-height: 40px;
    max-width: 140px;
    > div {
      min-height: 28px;
      height: auto;
      cursor: pointer;
    }
  }
  &.opaque-btn-as-input {
    height: auto;
    min-height: 40px;
    max-width: 140px;
    > div {
      min-height: 28px;
      height: auto;
      cursor: not-allowed;
    }
  }
`;
export const ButtonStyleSelector = styled.div<IProps>`
  height: 20px;
  width: 35px;
  background: ${(props) => (props.isActive ? "#57AC2D" : "#d9d9d9")};
  border-radius: ${(props) =>
    props.pillShape ? "25px" : props.roundedRect ? "5px" : "0px"};
  cursor: pointer;
`;

export const DescriptionCell = styled.div`
  flex: 1 1 0;
  .checkout-color-picker {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-1px, 40px);
    z-index: 1001 !important;
      #rbgcp-wrapper {
      // this is for the height width of the color picker box inside the color picker component
      > div:first-child > div:nth-child(2) > div:nth-child(2) {
        height: 150px !important;
      }
      > div:first-child > div:first-child {
        height: 165px !important;
      }
    }
  }

  @media (max-width: 1300px) {
    &.price-field-ss .styled-chkbox label {
      font-size: 14px;
    }
  }
`;
export const MediaBoxesWrapper = styled.div`
  .item-frame-wrapper {
    max-width: 600px;
  }
  &.lib-overlay-payment {
    height: 100%;
    .universal-search-input {
      padding: 6px 10px;
      width: 250px;
      border-radius: 5px;
      border: none;
      outline: none;
      height: 40px;
      &:focus {
        border: none;
        outline: none;
      }
    }
    .universal-single-select {
      padding: 10px;
      border-radius: 5px;
      border: none;
      cursor: pointer;
      width: 140px;
      height: 40px;
      &:focus {
        outline: none;
        border: none;
      }
      select {
        padding: 10px 20px 10px 5px;
      }
      option {
        cursor: pointer;
      }
    }
    .styled-radio,
    .styled-chkbox {
      label,
      input[type="radio"],
      input[type="checkbox"] {
        display: inline-block !important;
      }
    }
  }
`;
